module.exports = __webpack_public_path__ + "img/yennyacuna.d331a56c.jpg";